import classNames from 'classnames';
import React, { FC } from 'react';

import { CardLabelProps } from '../../models';

export const CardLabel: FC<CardLabelProps> = ({
  labelContent,
  srOnlyLabelPrefix,
  labelVariant,
  labelSize = 'large',
}) => (
  <div
    className={classNames('cds-card__label', {
      [`cds-card__label--${labelSize}`]: labelSize,
      [`cds-card__label--${labelVariant}`]: labelVariant,
    })}
  >
    {/* eslint-disable-next-line react/jsx-one-expression-per-line */}
    <span className="cds-sr-only">{srOnlyLabelPrefix} </span>
    {labelContent}
  </div>
);
